module.exports = __webpack_public_path__ + "static/media/img7.de46b8f9.jpg";